export const config = {
  src: [
    'audiosprites/audio.ogg',
    'audiosprites/audio.mp3',
  ],
  sprite: {
    big_win: [
      0,
      2377.845804988662,
    ],
    button_spin: [
      4000,
      568.1405895691612,
    ],
    end_free_spin: [
      6000,
      5056.621315192743,
    ],
    free_bet_big_win: [
      13000,
      1362.312925170068,
    ],
    free_bet_mega_win: [
      16000,
      2207.913832199548,
    ],
    free_bet_total_win: [
      20000,
      973.3560090702938,
    ],
    free_bet_ultra_win: [
      22000,
      1297.4149659863947,
    ],
    free_spin_ambient: [
      25000,
      27846.91609977324,
    ],
    free_spin_appears: [
      54000,
      2617.0294784580506,
    ],
    free_spin_music: [
      58000,
      42761.26984126984,
    ],
    free_spin_start: [
      102000,
      6512.517006802725,
    ],
    inside_buttons: [
      110000,
      506.6666666666606,
    ],
    main_ambient: [
      112000,
      35058.20861678004,
    ],
    main_music: [
      149000,
      125980.52154195012,
    ],
    mega_win: [
      276000,
      2671.904761904784,
    ],
    mult_x1: [
      280000,
      456.7120181405926,
    ],
    mult_x3: [
      282000,
      539.3650793650977,
    ],
    mult_x5: [
      284000,
      728.8208616780025,
    ],
    mult_x7: [
      286000,
      716.0770975056607,
    ],
    mult_x9: [
      288000,
      1120.5668934240407,
    ],
    outside_buttons: [
      291000,
      694.0136054421941,
    ],
    reel_spin: [
      293000,
      1837.9591836734903,
    ],
    reel_stop_01: [
      296000,
      177.4376417233725,
    ],
    reel_stop_02: [
      298000,
      187.34693877553354,
    ],
    reel_stop_03: [
      300000,
      176.87074829933636,
    ],
    reel_stop_04: [
      302000,
      178.5034013605582,
    ],
    reel_stop_05: [
      304000,
      194.87528344672,
    ],
    regular_win: [
      306000,
      1326.1224489796177,
    ],
    scatter_chance: [
      309000,
      2891.3378684807185,
    ],
    scatter_stop: [
      313000,
      1247.7551020407986,
    ],
    tap_to_play: [
      316000,
      6548.730158730166,
    ],
    ultra_win: [
      324000,
      2563.8548752834254,
    ],
    wild_stop: [
      328000,
      637.9591836734448,
    ],
  },
}
